import { render } from "./LandingOriginal.vue?vue&type=template&id=1765f41b&scoped=true&ts=true"
import script from "./LandingOriginal.vue?vue&type=script&lang=ts"
export * from "./LandingOriginal.vue?vue&type=script&lang=ts"

import "./LandingOriginal.vue?vue&type=style&index=0&id=1765f41b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1765f41b"]])

export default __exports__